// ** Dropdowns Imports
import IntlDropdown from "./IntlDropdown"
import CartDropdown from "./CartDropdown"
import UserDropdown from "./UserDropdown"
import NavbarSearch from "./NavbarSearch"
import NotificationDropdown from "./NotificationDropdown"

// ** Third Party Components
import { Sun, Moon, HelpCircle } from "react-feather"
import { useTranslation } from "react-i18next"

// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap"

// ** Redux
import { useSelector } from "react-redux"
import { selectUserRoles } from "@src/redux/slices/authSlice"

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props
  
  // ** Hooks
  const { t } = useTranslation()

  // ** Get user roles
  const userRoles = useSelector(selectUserRoles) || []
  const isPlanner = userRoles.includes('planner')
  const isPrinter = userRoles.includes('printer')
  const shouldHideCart = isPlanner || isPrinter

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />
    }
  }

  // ** WhatsApp Support Link
  const whatsappSupportUrl = "https://api.whatsapp.com/send/?phone=5541987486921&text=Ola%20tenho%20duvidas%20sobre%20a%20plataforma%20BDS%203D&type=phone_number&app_absent=0"

  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      <IntlDropdown />
      <NavItem className="d-none d-lg-block">
        <NavLink 
          className="nav-link-style" 
          href={whatsappSupportUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={t("Support")}
        >
          <HelpCircle className="ficon" />
        </NavLink>
      </NavItem>
      <NavItem className="d-none d-lg-block">
        <NavLink className="nav-link-style">
          <ThemeToggler />
        </NavLink>
      </NavItem>
      {!shouldHideCart && <CartDropdown />}
      <NotificationDropdown />
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser
